import axios from '@axios'

export const state = {
  destinations: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allDestinations: (state) => state.destinations,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_DESTINATION: (state, resp) => {
    if (!resp) return null
    state.destinations = resp.destinations
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_DESTINATION: (state, destination) => {
    state.destinations = state.destinations.filter((w) => w.id !== destination.id)
  },
}

export const actions = {
  async getDestinations({ commit }, params = {}) {
    await axios
      .get('/api/destinations', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_DESTINATION', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_DESTINATION',
          err.response.status === 404 ? { destinations: [] } : null
        )
      })
  },
  async createDestination({ commit }, destination) {
    return axios.post(`/api/destinations`, destination)
  },
  async editDestination({ commit }, destination) {
    return axios.put(`/api/destinations`, destination)
  },
  async deleteDestination({ commit }, destination) {
    await axios.delete(`/api/destinations/${destination.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_DESTINATION', destination)
      }
    })
  },
}
